<template>
  <el-card>
    <h3>球队快速查询</h3>
    <ul class="league_icon">
      <li v-for="(item, index) in League" :key="index">
        <el-dropdown trigger="click" placement="bottom">
          <div @click="handleClick(item.sclassId)">
            <svg
              class="icon icon_w"
              style="width: 40px; height: 40px"
              aria-hidden="true"
            >
              <use :xlink:href="item.icon"></use>
            </svg>
            <el-link :underline="false">{{ item.team_name }}</el-link>
          </div>
          <template #dropdown>
            <el-dropdown-menu v-if="teamList.length">
              <el-dropdown-item v-for="(ii, i) in teamList" :key="i"
                ><div style="padding: 0 4px">
                  <el-dropdown placement="top">
                    <div>{{ ii.rank }}、{{ ii.team_name }}</div>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item
                          v-for="(tt, t) in team_fast"
                          :key="t"
                          @click="goTimeSheet(ii.team_id, tt.team_type)"
                          ><div style="padding: 0 4px">
                            {{ tt.team_title }}
                          </div></el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div></el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
    </ul>
  </el-card>
</template>
<script>
import { ref, reactive, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
export default {
  setup() {
    let { proxy: _this } = getCurrentInstance()
    let router = useRouter()
    let League = reactive([
      {
        icon: '#icon-yingchao',
        team_name: '英超',
        sclassId: '36'
      },
      {
        icon: '#icon-dejia',
        team_name: '德甲',
        sclassId: '8'
      },
      {
        icon: '#icon-yijia',
        team_name: '意甲',
        sclassId: '34'
      },
      {
        icon: '#icon-xijia',
        team_name: '西甲',
        sclassId: '31'
      },
      {
        icon: '#icon-a-zu10290',
        team_name: '法甲',
        sclassId: '11'
      }
    ])
    let team_fast = reactive([
      {
        team_type: 'introduction',
        team_title: '球队介绍'
      },
      {
        team_type: 'lineup',
        team_title: '球队阵容'
      },
      {
        team_type: 'schedules',
        team_title: '球队赛程'
      },
      {
        team_type: 'player_transfers',
        team_title: '球员转会'
      },
      {
        team_type: 'position',
        team_title: '球队位置'
      },
      {
        team_type: 'history_score',
        team_title: '历年战绩'
      },
      {
        team_type: 'trend_charts',
        team_title: '历年球路'
      },
      {
        team_type: 'time_sheet',
        team_title: '出勤表'
      },
      {
        team_type: 'national_match',
        team_title: '国家比赛统计'
      },
      {
        team_type: 'stoppage_time',
        team_title: '球员伤停统计'
      }
    ])
    let sclassInfo = async (sclassId) => {
      let { data: res } = await _this.$http.get(`soccer/sclass/${sclassId}`)
      league_score(sclassId, res.data.select_season)
    }
    let teamList = ref([])
    let league_score = async (sclassId, select_season) => {
      let { data: res } = await _this.$http.get(
        `/soccer/sclass/${sclassId}/league_score`,
        {
          params: {
            match_season: select_season
          }
        }
      )
      teamList.value = res.data.all_score
    }
    let handleClick = (sclassId) => {
      teamList.value = []
      sclassInfo(sclassId)
    }
    // 跳转出勤表
    let goTimeSheet = (team_id, style) => {
      console.log(team_id)
      let routeUrl = router.resolve({
        path: `/soccer/team/${team_id}/${style}`
      })
      window.open(routeUrl.href, '_blank')
    }
    return {
      League,
      handleClick,
      teamList,
      goTimeSheet,
      team_fast
    }
  }
}
</script>
<style lang="less" scoped>
h3 {
  font-size: 16px;
  font-weight: normal;
  padding: 0 0 10px 0;
  color: rgb(232, 75, 91);
  font-weight: 600;
}
.el-dropdown-menu__item {
  padding: 0 6px;
  .el-dropdown-selfdefine {
    padding: 0 10px;
  }
}
.league_icon {
  display: flex;
  justify-content: space-between;
  li {
    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .el-link {
        margin-top: 10px;
      }
      &:hover {
        .el-link {
          color: #409eff;
        }
      }
    }
  }
}
</style>
